import { ArticlesInstagramStore, ArticlesInstagramActions } from './types';

export const defaultState: ArticlesInstagramStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  instagrams: [],
  instagramsCount: 0,
  currentPage: 0,
};

const reducer = (
  state: ArticlesInstagramStore = defaultState,
  action: { type: ArticlesInstagramActions; payload?: any }
): ArticlesInstagramStore => {
  switch (action.type) {
    case ArticlesInstagramActions.FetchBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case ArticlesInstagramActions.FetchError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case ArticlesInstagramActions.FetchSuccess: {
      const currentPage = action.payload?.currentPage || 0;
      const instagrams =
        currentPage <= 0
          ? [...action.payload.instagrams]
          : [...state.instagrams, ...action.payload.instagrams];

      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
        instagrams,
        instagramsCount: action.payload.instagramsCount,
        currentPage,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
